import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Breadcrumb from '../Common/Breadcrumb';
import Footer from '../Common/Footer';
import Helper from '../../../Helper';
import HttpRequest from '../../../Libraries/HttpRequest/HttpRequest';
import DataTable from '../Datatable/Index';
import Pagination from '../Pagination/Index';
import api from '../../../Api'
import VideoPlayer from '../../VideoPlayer';
import { StopOutlined, CheckCircleOutlined } from '@ant-design/icons'
import { Avatar } from 'antd'

let page_no = 1;
let search_keyword = '';

function Index() {
    const [paginationData, setPaginationData] = useState({});
    const [data, setData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [path, setPath] = useState('');
    const [title, setTitle] = useState('');

    useEffect(() => {
        getData()
    }, []);

    async function getData() {
        let params = {
            page: page_no,
        }
        params = Helper.makeQueryStingFromJson(params);
        let admin_route = api.get_reported_user;
        let url = admin_route.url + params;
        let response = await HttpRequest.makeRequest(admin_route.method, url)
        setData(response.data.data)
        setPaginationData(response.data.paginate);
    }

    async function updateUserAcitvity(record) {
        let admin_route = api.update_user_activity;
        let url = admin_route.url + record.reported_user.id;
        let payload = { is_active: Number(!record.reported_user.is_active) }
        let response = await HttpRequest.makeRequest(admin_route.method, url, payload)
        getData()
    }

    function pageChange(page) {
        console.log(page)
        page_no = page
        getData()
    }

    function onModal(video_path, video_title) {
        setPath(video_path)
        setTitle(video_title)
        setVisible(true)
    }


    let columns = [
        {
            type: 'callback',
            title: '',
            key: 'slug',
            sort: false,
            cb: record => <Avatar src={record?.reported_user.images ? Helper.generateImageURL(record?.reported_user.images[0]) : '/images/placeholder.jpg'} />
        },
        {
            type: 'text',
            title: 'Reason',
            key: 'reason',
            sort: false,
        },
        {
            type: 'callback',
            title: 'Name',
            sort: true,
            key: 'reported-user-name',
            cb: record => <p>{record.reported_by.first_name + " " + record.reported_by.last_name}</p>
        },
        {
            type: 'callback',
            title: 'Name',
            sort: true,
            key: 'reported-user-email',
            cb: record => <p>{record?.reported_user?.email}</p>
        },
        {
            type: 'callback',
            title: 'Reported By',
            sort: true,
            key: 'author-name',
            cb: record => <p>{`${record.reported_by.first_name + " " + record.reported_by.last_name} (${record.reported_by.email})`}</p>
        },
        {
            type: 'timestamp',
            title: 'Created At',
            key: 'created_at',
            sort: true,
        },
    ];

    let config = {
        // bulk_delete: true,
        // search: true,
        // bulk_delete_cb: bulkDelete,
        // filter_cb: filter
    }


    return (
        <>
            <Header />
            <Sidebar />
            <Breadcrumb page_title='Reports Management' />
            <section className="main-content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-default">
                                <div className="row">
                                    <div className="col-md-6">
                                        Reported Users Listing
                                    </div>
                                    {/* <div className="col-md-6">
                                  <Link className="btn btn-info pull-right" to={+ 'admin/cms-users/add'}>Add Cms User</Link>
                              </div> */}
                                </div>
                            </div>
                            <div className="card-body">
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <DataTable columns={columns} config={config} data={data} />
                                    </div>
                                    <div className='col-md-12'>
                                        <nav className='pull-right'>
                                            <Pagination paginationData={paginationData} callback={pageChange} />
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </section>
            <VideoPlayer visible={visible} setVisible={setVisible} path={path} setPath={setPath} title={title} />
        </>
    )
}
export default React.memo(Index)
